module.exports = __webpack_public_path__ + "img/svg/no-competitions.31e51d911796dff95c1e61f26d3979fb.svg";